module.exports = __webpack_public_path__ + "static/stars-21904a43ebe3960867871a1193473368.png";